import formatUTCDate from '@/shared/tools/formatUTCDate'

export const telecomFormParametersGeneration = (
  customerData,
  billingData,
  mainAddressData,
  telecomContractData,
  telecomCharacteristicsData,
  id,
  country,
  action,
  identityData = {},
  residenceAddressData = {},
  invoicingAddressData = {},
) => {
  // eslint-disable-next-line compat/compat
  const options = new URLSearchParams()

  if (action !== '') {
    options.append('action_requested', action)
  }

  options.append('id', id)
  options.append('zoho_id', customerData.zohoId)
  options.append('prestation_type', telecomCharacteristicsData.prestationType)
  options.append('product_type', telecomCharacteristicsData.productType)
  options.append('referral_firstname', customerData.referralFirstName)
  options.append('referral_lastname', customerData.referralSecondName)
  options.append('city_id', mainAddressData.inseeCode ?? '')
  options.append('city', mainAddressData.city ?? '')
  options.append('zipcode', mainAddressData.zipcode ?? '')
  options.append('conso_street_name', mainAddressData.address ?? '')
  options.append('conso_residence_type', mainAddressData.residenceType ?? '-1')
  options.append('housing_type', mainAddressData.housingType ?? '')
  options.append('street_number', mainAddressData.streetNumber ?? '')
  options.append('conso_floor', mainAddressData.floor ?? '')
  options.append('conso_appartment_number', mainAddressData.appartmentNumber ?? '')
  options.append('conso_additional_information', mainAddressData.additionalInformation ?? '')
  options.append('tenant_type', mainAddressData.tenantType ?? '-1')

  options.append('offer_id', telecomContractData.offerId ? parseInt(telecomContractData.offerId) : '')
  options.append('organisation_id', telecomContractData.providerId ? parseInt(telecomContractData.providerId) : '')
  options.append('lang', country)
  options.append('_form_mode', 'telesales')
  options.append('provider_external_id', telecomContractData.providerExternalId)
  options.append('providers_options', JSON.stringify(telecomContractData.providerOptions))

  options.append('iban', billingData.iban ?? '')

  if (billingData.businessCard === true) {
    options.append('business_card', '1')
  }

  if (billingData.bic.length > 0) {
    options.append('bic', billingData.bic)
  }

  options.append('disclaimer', customerData.dataCollectionAuth ? '1' : '0')
  options.append('civility', customerData.civility ?? '-1')
  options.append('lastname', customerData.surname ?? '')
  options.append('firstname', customerData.name ?? '')
  options.append('email', customerData.email ?? '')
  options.append('neverbounce_result', customerData.neverbounce_result)
  options.append('phone1', customerData.phone1 ?? '')
  options.append('bac_voucher', customerData.bacVoucher ? '1' : '0')

  if (customerData.web_callback.callbackTime !== '' && customerData.web_callback.callbackDate !== '') {
    const date = new Date(customerData.web_callback.callbackDate + ' ' + customerData.web_callback.callbackTime)
    options.append('web_callback', formatUTCDate(date) ?? '')
  }

  options.append('phone2', customerData.phone2 ?? '')
  options.append('pro_social_reason', customerData.pro_social_reason)
  if (customerData.pro_siret?.length > 0) {
    options.append('pro_siret', customerData.pro_siret)
  }

  if (customerData.secondName) {
    options.append('secondName', '1')
    options.append('civility2', customerData.civility2 ?? '-1')
    options.append('lastname2', customerData.surname2)
    options.append('firstname2', customerData.name2)
  }

  if (customerData.comments !== '') {
    options.append('subscription_comments', customerData.comments)
  }

  if (country === 'it') {
    options.append('tax_id_code', customerData.tax_id_code ?? '')
    options.append('city_id', mainAddressData.cityId ?? '')
    options.append('identity_document_type', identityData.documentType ?? null)
    options.append('identity_document_number', identityData.documentNumber ?? null)
    options.append('identity_expiration_date', identityData.expirationDate ?? null)
    options.append('identity_created_date', identityData.createdDate ?? null)
    options.append('identity_issuing_entity', identityData.issuingEntity ?? null)
    options.append('identity_issuing_city', identityData.issuingCity ?? null)
    options.append('born_city', customerData.bornCity ?? '')
    options.append('mobile_migration_code', telecomCharacteristicsData.mobileMigrationCode ?? '')
    options.append('iccid_migration', telecomCharacteristicsData.iccidMigration ?? '')
    options.append('previous_provider', telecomCharacteristicsData.previousProvider ?? '')
    options.append('contract_type', telecomCharacteristicsData.contractType ?? '')

    if (billingData?.paymentMode) {
      options.append('payment_mode', billingData.paymentMode)
    }

    if (billingData?.iban?.length > 0) {
      options.append('iban', billingData.iban)
    }

    if (billingData?.bic?.length > 0) {
      options.append('bic', billingData.bic)
    }

    if (billingData.differentAccountHolder === true) {
      options.append('owner_name_different', 1)
      options.append('owner_lastname', billingData.accountHolderLastname ?? '')
      options.append('owner_firstname', billingData.accountHolderFirstname ?? '')
      options.append('owner_tax_id_code', billingData.accountHolderTaxIdCode ?? '')
    }
  }

  if (invoicingAddressData.showCheckbox === true) {
    options.append('facturation_address_different', '1')
    options.append('fact_street_name', invoicingAddressData.address ?? '')
    options.append('fact_street_number', invoicingAddressData.streetNumber ?? '')
    options.append('fact_floor', invoicingAddressData.floor ?? '')
    options.append('fact_appartment_number', invoicingAddressData.appartmentNumber ?? '')
    options.append('fact_complement_address', invoicingAddressData.additionalInformation ?? '')
    options.append('fact_city', invoicingAddressData.city)
    options.append('fact_zipcode', invoicingAddressData.zipcode)
    options.append('fact_country', invoicingAddressData.country)
  }

  if (residenceAddressData.optionChecked === true) {
    // For Italy only if we have a different residence address
    options.append('residence_address_different', '1')
    options.append('residence_city', residenceAddressData.city ?? '')
    options.append('residence_province', residenceAddressData.province ?? '')
    options.append('residence_zipcode', residenceAddressData.zipcode ?? '')
    options.append('residence_street_name', residenceAddressData.address ?? '')
    options.append('residence_street_number', residenceAddressData.streetNumber ?? '')
    options.append('residence_floor', residenceAddressData.floor ?? '')
    options.append('residence_appartment_number', residenceAddressData.appartmentNumber ?? '')
    options.append('residence_additional_information', residenceAddressData.additionalInformation ?? '')
  }

  return options
}
